export default __webpack_public_path__ + "static/media/illu_graph.d4f2db17.png";